// Helpers for the beta optimizer's "Budget Allocation Requirement" feature.
// When a plan uses spend_up_to, simulation.budget is a CEILING, not the amount
// actually invested. The real invested total is precomputed at
// simulation.results.invest.budget (same value the mix charts divide by).

// true only for beta plans (optimizer_version 2) configured with a spend ceiling.
export function isSpendUpTo (sim) {
  return !!(sim && sim.optimizer_version === 2 && sim.budget_allocation === 'spend_up_to')
}

// Real invested amount (precomputed), or null when the plan has no results yet.
export function investedBudget (sim) {
  if (sim && sim.results && sim.results.invest && typeof sim.results.invest.budget === 'number') {
    return sim.results.invest.budget
  }
  return null
}
